import GeolocationModal from './GeolocationModal';

export default GeolocationModal;
